module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAABOklEQVQ4jZ2UwStEYRTFfzRFjayIbPwJUhbs2FiRlIWaUihrfwIbpZTsJBsLLM2UWFrMzkYSUq/YarJSInL0Tfer17vzypuz+d493zmne3u3r0MSQA+QAAPAG9Ak/4k+4BMYA+6RtCNpRNK4pF+1hzlJQ5K2SdkHQ7eS6gUinyR1m+9V9nGbEswYt++sHjXThuk+7DYJxENGumHCNRfhNcsZ/jmQj04unUsqSZqS9JO5W7SwA+eSXvICA+bNWJbUkPQladi4Uae2wM6czVgFzoAqMAH0A11AGagBN8C0cwW06HDduqimuIqk2VR9bZqFViPfpYhNEx67YTzqpl1J3TT/cmLFlgkOnTUfl5mNaMTFjju1WyAs4tS8e6GI6eE8aiMs4sIyluLjMAlcAe/Ad4GHIaAE9AIV4OQPXrZPfPQ5KiwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email.png
// module id = vCvB
// module chunks = 1